import React, { FunctionComponent } from 'react';
import { useMeContext } from 'modules/me';
import { LocaleIntlProvider } from './LocaleIntlProvider';

export const MeLocaleIntlProvider: FunctionComponent = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  const me = useMeContext();
  const locale = me?.locale?.language?.languageCode || 'en-US';
  const ianaName = me?.locale?.timeZone?.ianaName;
  return (
    <LocaleIntlProvider locale={locale} ianaName={ianaName}>
      {children}
    </LocaleIntlProvider>
  );
};
